import ReviewAccountPage from './ReviewAccountPage/ReviewAccountPage.config';
import WelcomePage from "./WelcomePage/WelcomePage.config";
import signInSpinPage from './SpinPage/SignInSpinPage.config';
import processSpinPage from './SpinPage/ProcessSpinPage.config';
import ProductInfoPage from './ProductInfoPage/ProductInfoPage.config';
import createCasePage from './createCasePage/createCasePage.config';
import createCaseSuccessPage from './createCaseSuccessPage/createCaseSuccessPage.config';
import agentAvailable from './agentAvailablePage/agentAvailable.config';
import authorizeRequestPage from './authorizeRequestPage/authorizeRequestPage.config';
import successPage from './successPage/successPage.config';
import errorPage from './errorPage/errorPage.config';



export default {
  ReviewAccountPage,
  signInSpinPage,
  createCasePage,
  createCaseSuccessPage,
  WelcomePage,
  ProductInfoPage,
  agentAvailable,
  authorizeRequestPage,
  processSpinPage,
  successPage,
  errorPage,
};
